export default __webpack_public_path__ + "7a6f33afee06b87ad825ee924b59bec2.svg";